import { render, staticRenderFns } from "./LaudoUsuarioForm.vue?vue&type=template&id=56dd31aa&"
import script from "./LaudoUsuarioForm.vue?vue&type=script&lang=js&"
export * from "./LaudoUsuarioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports